import React from 'react';

import Header from '../layout/Header.jsx';
import AvatarPicker from '../blocks/AvatarPicker.jsx';

import meta from '../../config/meta';

const PageAvatar = () => {
  meta.set({ title: '選擇您的帳戶頭像' });

  return (
    <>
      <Header
        bg={{
          left: '/assets/img/header-3-left.png',
          right: '/assets/img/header-3-right.png',
          color: '#e2f6fb',
        }}
      >
        <h3 className="text-center my-4">
          我的帳戶
        </h3>
      </Header>
      <AvatarPicker />
    </>
  );
};

export default PageAvatar;
